"use client";

import React from "react";
import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="35069" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-24 animate-pulse rounded bg-muted/20" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackLinks = [{
      label: "Home",
      to: "/HomePage"
    }, {
      label: "Services",
      to: "/ServicesPage"
    }, {
      label: "Gallery",
      to: "#"
    }, {
      label: "About Us",
      to: "#"
    }, {
      label: "Contact",
      to: "/ContactPage"
    }];
    return <nav className="flex flex-col gap-3">
        {fallbackLinks.map((link, i) => <Link key={i} to={link.to} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium w-fit" data-index={i}>
            {link.label}
          </Link>)}
      </nav>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium w-fit" data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="site-footer" className="dark bg-[#000000] text-foreground pt-16 pb-8 border-t border-border/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">Coastal Prestige Mowing &amp; Maintenance delivers professional lawn care and property management across the Central Coast.&nbsp;</p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Quick Links</h3>
            <MenuProvider menu_id="17" className="w-full">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-semibold tracking-tight text-foreground">Get In Touch</h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3 text-muted-foreground group">
                <Phone className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-sm group-hover:text-foreground transition-colors">
                  0410 147 510
                </span>
              </div>
              <div className="flex items-start gap-3 text-muted-foreground group">
                <Mail className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-sm group-hover:text-foreground transition-colors">
                  coastalprestigemowing@gmail.com
                </span>
              </div>
              <div className="flex items-start gap-3 text-muted-foreground group">
                <MapPin className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-sm group-hover:text-foreground transition-colors">
                  Central Coast, NSW
                </span>
              </div>
              <Link to="https://www.instagram.com/coastalprestigemowing/?hl=en" newTab className="flex items-start gap-3 text-muted-foreground group">
                <Instagram className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-sm group-hover:text-foreground transition-colors">
                  Instagram
                </span>
              </Link>
              <Link to="https://www.facebook.com/Coastalprestigemowing/" newTab className="flex items-start gap-3 text-muted-foreground group">
                <Facebook className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-sm group-hover:text-foreground transition-colors">
                  Facebook
                </span>
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col items-start lg:items-end gap-6">
            <img src="https://coastal-prestige.websiteshop.au/wp-content/uploads/2026/03/three-best-rated.png" alt="Three Best Rated Award - Top 3 Lawn Care Services in Central Coast" className="h-36 w-auto object-contain" />
          </div>
          
        </div>

        <Separator className="bg-border/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground/60">
          <p>
            &copy; {currentYear} Coastal Prestige Mowing & Maintenance. All rights reserved.
          </p>
          <div className="flex items-center gap-1">
            <span>Servicing the</span>
            <Link to="/HomePage" className="hover:text-primary transition-colors font-medium">
              Central Coast
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}